import React, { useEffect, useMemo, useState } from 'react';

const SpotInfo = ({ selectedLocation, locationName, latitude, longitude, timezone, utcOffset }) => {
    const [localTime, setLocalTime] = useState('');

    const formatCoord = useMemo(() => {
        return (value) => {
            const num = typeof value === 'number' ? value : Number(value);
            return Number.isFinite(num) ? num.toFixed(4) : 'N/A';
        };
    }, []);

    useEffect(() => {
        // Avoid SSR/client hydration mismatches: render time only after mount.
        if (utcOffset === null || utcOffset === undefined) {
            setLocalTime('N/A');
            return;
        }

        const update = () => {
            const now = new Date();
            const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
            const local = new Date(utcTime + (utcOffset * 1000));
            setLocalTime(local.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
        };

        update();
        const id = setInterval(update, 60_000);
        return () => clearInterval(id);
    }, [utcOffset]);

    return (
        <div className="mt-1 mb-0.5">
            {selectedLocation ? (
                <div className="space-y-0.5">
                    <h1 className="text-2xl font-bold text-zinc-800 dark:text-zinc-100">
                        {selectedLocation.text}
                    </h1>
                    
                    <p className="text-xs sm:text-sm text-zinc-500 dark:text-zinc-400">
                        Lat {formatCoord(selectedLocation.latitude)} Lon {formatCoord(selectedLocation.longitude)} &nbsp; {timezone || 'N/A'} {localTime}
                    </p>
   
                </div>
            ) : locationName && latitude && longitude ? (
                <div className="space-y-0.5">
                    <h1 className="text-2xl font-bold text-zinc-800 dark:text-zinc-100">
                        {locationName}
                    </h1>
                    <p className="text-xs sm:text-sm text-zinc-500 dark:text-zinc-400">
                        Lat {formatCoord(latitude)} Lon {formatCoord(longitude)} &nbsp; {timezone || 'N/A'} {localTime}
                    </p>

                </div>
            ) : null}
        </div>
    );
};

export default SpotInfo;